module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Semibold.67d2da6.otf";